module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_intelliquant.8470f1b4fbb7467040cc6af538a37a56.png";